import {Button} from '@mantine/core';
import {AiOutlineReload} from 'react-icons/ai';
import {useQueryClient} from '@tanstack/react-query';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({ queryKey: ['provider-mappings'] });
    };

    return (
        <Button
            leftSection={<AiOutlineReload size={16}/>}
            variant="outline"
            onClick={handleReload}
        >
            Reload
        </Button>
    );
};